import { Injectable } from '@angular/core';
import { PersonHelbred } from '@features/helbred/person-helbred/person-helbred.model';
import { RestApi } from '@core/api/rest.api';

@Injectable({
  providedIn: 'root'
})
export class PersonHelbredApi extends RestApi<PersonHelbred> {
  override endpoint='/api/admin/personhelbred';
}
